import React, { useState, useEffect, useContext } from 'react';
import { ProSidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Box, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import 'react-pro-sidebar/dist/css/styles.css';
import './style.css';
import { tokens } from '../../theme';
import {
  HomeOutlined as HomeOutlinedIcon,
  MenuOutlined as MenuOutlinedIcon
} from '@mui/icons-material';
import { jwtDecode } from 'jwt-decode';
import { ADMIN, DMS, SKOLA } from 'src/constants/role';
import { useTranslation } from 'react-i18next';
import { RoleContext } from 'src/context/roleContext';
import { getSchoolInfo } from 'src/api/schoolMetod';
import SchoolSidebarItems from 'src/components/helpComponents/SchoolSidebarItems';
import AdminSideBarItems from 'src/components/helpComponents/AdminSidebarItems';
import PaymentIcon from '@mui/icons-material/Payment';

/* GENERALNI SIDE BAR  */
const Sidebar = ({ onLogout }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const [schoolLogin, setSchoolLogin] = useState('');
  const [displayName, setDisplayName] = useState('');
  const { role, userId } = useContext(RoleContext);
  const { t } = useTranslation();

  const [selected, setSelected] = useState(
    role === DMS ? t('dialog.payment') : 'Почетна страница'
  );

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        if (role === SKOLA) {
          const id = userId.match(/\d+/);
          if (id) {
            const data = await getSchoolInfo(id[0]);
            setSchoolLogin(data);
            setDisplayName(data['name']);
          }
        } else {
          const token = localStorage.getItem('token');
          if (token) {
            const decodedToken = jwtDecode(token);
            setDisplayName(decodedToken.user_id);
          }
        }
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
    };

    fetchUserInfo();
  }, [role, userId]);

  return (
    <Box className="sidebar-container" sx={{ backgroundColor: '#1fbaf12e' }}>
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            className="menu-item"
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <Typography variant="h3" color={colors.grey[100]}>
                  <p className="titleSide">{t('general.kengur')}</p>
                </Typography>
                {/* <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton> */}
              </Box>
            )}
          </MenuItem>

          {/* KENGUR LOGO AND DISPLAY NAME */}
          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="profile-user"
                  width="100px"
                  height="100px"
                  src="/kengur2/assets/kengur.png"
                  style={{ cursor: 'pointer', borderRadius: '50%' }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: '10px 0 0 20px' }}
                >
                  {displayName || ''}
                </Typography>
              </Box>
            </Box>
          )}

          {/* ALL LIST */}
          <Box paddingLeft={isCollapsed ? undefined : '10%'}>
            {/* New section for Students - SCHOOL VIEW */}
            {role === SKOLA ? (
              <>
                <Item
                  title={t('meni.homePage')}
                  to="/"
                  icon={<HomeOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
                <SchoolSidebarItems
                  selected={selected}
                  setSelected={setSelected}
                  onLogout={onLogout}
                />
              </>
            ) : role === ADMIN ? (
              <AdminSideBarItems
                selected={selected}
                setSelected={setSelected}
                onLogout={onLogout}
              />
            ) : role === DMS ? (
              <Menu iconShape="circle">
                <Item
                  title={t('dialog.payment')}
                  to="/pay"
                  icon={<PaymentIcon />}
                  selected={selected}
                  setSelected={setSelected}
                />
              </Menu>
            ) : (
              <Typography
                variant="h6"
                color={colors.grey[300]}
                sx={{ m: '15px 0 5px 20px' }}
              >
                Data
              </Typography>
            )}
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

const Item = ({ title, to, icon, selected, setSelected }) => {

  return (
    <MenuItem
      active={selected === title}
      style={{ color: selected === title ? '#007bff' : '#333333' }}
      onClick={() => setSelected(title)}
      icon={icon}
      className={`menu-item ${selected === title ? 'active' : ''}`}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

export default Sidebar;
